import { apiClient } from 'api/apiClient';

const RESOURCE = '/publicmappingbatches/retainers';

export interface IRetainerPDFParams {
	objectId: number;
}
export interface IRetainerPDFResponse {
	link: string;
}

export const getRetainerPDF = async (
	params: IRetainerPDFParams
): Promise<string> => {
	const { data } = (await apiClient.post(`${RESOURCE}`, params)) as {
		data: IRetainerPDFResponse;
	};

	return data.link;
};
